import { toast } from "react-toastify";
import { postApiCall } from "../Handlers/HttpHandler"

const FILTERS_CACHE_KEY = "transactionFiltersCache";

export const getTransactionFilters = async(token) => {
    try {
        const cached = sessionStorage.getItem(FILTERS_CACHE_KEY);
        if (cached) {
            return JSON.parse(cached);
        }

        var filters = await postApiCall("transaction/get-filters", null, token);

        if (filters.data !== null) {
            sessionStorage.setItem(FILTERS_CACHE_KEY, JSON.stringify(filters.data));
            return filters.data;
        } else {
            toast.error(filters.error);
            return null;
        }
    } catch (ex) {
        toast.error(ex);
        return null;
    }
}

export const getTransactionById = async(id, token) => {
    try {
        let body = {
            id: id,
            dateTimeFrom: "2000-01-01 00:00:00"
        }
        var transactionResp = await postApiCall("transaction/get", body, token);

        if (transactionResp.data && transactionResp.data.length > 0) {
            return transactionResp.data[0];
        } else {
            return null;
        }
    } catch (ex) {
        toast.error(ex);
        return null;
    }
}